<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="work_black_24dp 1" clip-path="url(#clip0_2545_15044)">
<path id="Vector" d="M13.3333 3.99967H10.6666V2.66634C10.6666 1.92634 10.0733 1.33301 9.33325 1.33301H6.66658C5.92659 1.33301 5.33325 1.92634 5.33325 2.66634V3.99967H2.66659C1.92659 3.99967 1.33992 4.59301 1.33992 5.33301L1.33325 12.6663C1.33325 13.4063 1.92659 13.9997 2.66659 13.9997H13.3333C14.0733 13.9997 14.6666 13.4063 14.6666 12.6663V5.33301C14.6666 4.59301 14.0733 3.99967 13.3333 3.99967ZM9.33325 3.99967H6.66658V2.66634H9.33325V3.99967Z" fill="#B8C5CE"/>
</g>
<defs>
<clipPath id="clip0_2545_15044">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg>
